import * as React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import {
    fetchMarcas,
    fetchCategorias,
    fetchPublicaciones, // NO SE ESTA USANDO fetchPublicaciones
    setFiltroPublicacion,
    fetchPublicacionesEncabezado
} from '../../../actions/publicacionesActions';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import { customStyleFilter, DropDownArrow, filterSelectMenuPortalProps } from '../../../template/CustomStyle';
import { filtroMedioMes } from '../../../utilities/fechasFiltro';
import { getEstadoPublicacionFromId, normalizeEstadoPublicacion } from '../../../helper/publicacionHelper';
import PropTypes from 'prop-types';

const fechaFiltro = filtroMedioMes();
const PUBLICACIONES_PRESERVE_FILTER_KEY = "publicacionesPreserveFilter";

class PublicacionesFilter extends React.Component {
    constructor(props) {
        super(props);
        const filtroInicial = props.filtro ?? props.filtroPublicaciones ?? {};
        const estadoGuardado = filtroInicial.estado;
        const idPublicacionGuardada = (filtroInicial.idPublicacion || "").toString().trim();
        const estadoNormalizado = this.normalizeEstadoValue(estadoGuardado);
        let estado = filtroInicial.estadoLabel || this.switchEstado(estadoNormalizado) || "Todos";

        // 🔥 reconstruir seller correctamente
        const sellerId = filtroInicial.idSeller;

        const sellerFromList = (props.sellers || []).find(
            s => s.value?.toString() === sellerId?.toString()
        );

        const seller = sellerId
            ? {
                value: sellerId,
                label:
                    filtroInicial.idSellerLabel ||
                    sellerFromList?.label ||
                    "Seleccionado"
            }
            : { label: "Todos", value: "" };

        // ✅ STOCK BIEN ARMADO
        const stockValue = filtroInicial.sinStock;
        const sinStock =
            stockValue === true || stockValue === "true"
                ? { value: true, label: "Sin Stock" }
                : stockValue === false || stockValue === "false"
                    ? { value: false, label: "Con Stock" }
                    : null;

        this.state = {
            skuSeller: filtroInicial.skuSeller,
            marca: {
                label: filtroInicial.marcaLabel || "Todos",
                // Normalizar a string para coincidir con listaMarca (que usa toString)
                value:
                    typeof filtroInicial.marca === "object"
                        ? (filtroInicial.marca?.codigo ?? "").toString()
                        : (filtroInicial.marca ?? "").toString()
            },
            categoria: {
                label: filtroInicial.categoriaLabel || "Todos",
                value:
                    typeof filtroInicial.categoria === "object"
                        ? (filtroInicial.categoria?.codigo ?? "").toString()
                        : (filtroInicial.categoria ?? "").toString()
            },
            seller: seller,
            estado: {
                label: estado ?? "Todos",
                value: estadoNormalizado ?? ""
            },
            idTipoPublicacion: {
                label: filtroInicial.idTipoPublicacionLabel ?? "Todos",
                value: filtroInicial.idTipoPublicacion ?? ""
            },
            sinStock: sinStock ?? { label: "Todos", value: "" },
            fechaPubDesde: filtroInicial.fechaPubDesde ?? fechaFiltro.desde,
            fechaPubHasta: filtroInicial.fechaPubHasta ?? fechaFiltro.hasta,
            skuMarket: filtroInicial.skuMarket,
            variaciones: [],
            tipoPublicacion: [],
            idPublicacion: filtroInicial.idPublicacion,
            estadoBloqueadoPorRespuesta:
                estadoNormalizado === "eliminado" &&
                idPublicacionGuardada !== ""
        };
    }

    getFiltroPropFrom = (props) => {
        return props?.filtro ?? props?.filtroPublicaciones ?? {};
    }

    normalizeEstadoDescripcion = (descripcion) => {
        const normalizedDescripcion = (descripcion || "")
            .toString()
            .trim()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\s+/g, "_");

        const equivalencias = {
            activa: "activo",
            activo: "activo",
            pendiente: "pendiente_activacion",
            pendiente_activacion: "pendiente_activacion",
            pausada: "pausado",
            pausado: "pausado",
            en_revision: "en_revision",
            revision: "en_revision",
            eliminado: "eliminado",
        };

        return equivalencias[normalizedDescripcion] || normalizedDescripcion;
    }

    normalizeEstadoValue = (estado) => {
        if (estado == null || estado === "") return "";

        if (typeof estado === "number") {
            return getEstadoPublicacionFromId(estado);
        }

        if (typeof estado === "string") {
            return this.normalizeEstadoDescripcion(estado);
        }

        if (typeof estado === "object") {
            const codigo = Number(estado.codigo ?? estado.Codigo);
            if (!Number.isNaN(codigo) && codigo > 0) {
                return getEstadoPublicacionFromId(codigo);
            }

            const descripcion = estado.descripcion ?? estado.Descripcion ?? "";
            return this.normalizeEstadoDescripcion(descripcion);
        }

        return "";
    }

    componentDidMount() {
        // Inicializar opciones de tipoPublicacion y asegurar label si existe en filtro
        this.mapTipoPublicacion();

        const filtro = this.getFiltroPropFrom(this.props);
        const idTipo = filtro?.idTipoPublicacion ?? filtro?.idTipoPubli;
        const labelTipo = filtro?.idTipoPublicacionLabel;
        if (idTipo) {
            const found = (this.props.tipoPublicacion || []).find(t => (t.codigo ?? t.value)?.toString() === idTipo?.toString());
            if (found) {
                this.setState({
                    idTipoPublicacion: {
                        value: found.codigo ?? found.value ?? "",
                        label: found.descripcion ?? found.label ?? labelTipo ?? "Todos"
                    }
                });
            } else if (labelTipo) {
                this.setState({
                    idTipoPublicacion: {
                        value: idTipo ?? "",
                        label: labelTipo ?? "Todos"
                    }
                });
            }
        }
    }

    componentDidUpdate(prevProps) {
        const prevFiltro = this.getFiltroPropFrom(prevProps);
        const currFiltro = this.getFiltroPropFrom(this.props);
        const resultadosPrevios = this.getResultadosPublicaciones(prevProps.publicaciones);
        const resultadosActuales = this.getResultadosPublicaciones(this.props.publicaciones);

        if (resultadosPrevios !== resultadosActuales && resultadosActuales.length) {
            const estadoResultado = normalizeEstadoPublicacion(resultadosActuales[0]?.estado);
            const idPublicacionActual = (this.state.idPublicacion || "").toString().trim();

            if (estadoResultado === "eliminado" && idPublicacionActual !== "") {
                if (this.state.estado?.value !== "eliminado" || !this.state.estadoBloqueadoPorRespuesta) {
                    this.setState({
                        estado: { value: "eliminado", label: "ELIMINADO" },
                        estadoBloqueadoPorRespuesta: true
                    });

                    if (this.props.persistFilterInRedux !== false && currFiltro?.estado !== "eliminado") {
                        this.props.setFiltroPublicacion({
                            ...currFiltro,
                            estado: "eliminado",
                            estadoLabel: "ELIMINADO",
                            idPublicacion: idPublicacionActual
                        });
                    }
                }
            }
        }

        // 🔥 FIX SELLER: sincronizar con Redux y además sincronizar marca y categoría
        if (prevFiltro !== currFiltro) {
            const sellerId = currFiltro.idSeller;

            const sellerFromList = (this.props.sellers || []).find(
                s => s.value?.toString() === sellerId?.toString()
            );

            // Reconstruir marca desde filtro o lista si está disponible
            const marcaVal = currFiltro?.marca;
            const marcaLabel = currFiltro?.marcaLabel;
            const marcaFromList = (this.props.marcas || []).find(
                m => (m.value?.toString() ?? "") === ((marcaVal ?? "").toString())
            );
            const marcaState = marcaVal !== undefined && marcaVal !== null && marcaVal !== ""
                ? { value: (marcaVal).toString(), label: marcaLabel || marcaFromList?.label || "" }
                : { label: "Todos", value: "" };

            // Reconstruir categoría desde filtro o lista si está disponible
            const categoriaVal = currFiltro?.categoria;
            const categoriaLabel = currFiltro?.categoriaLabel;
            const categoriaFromList = (this.props.categorias || []).find(
                c => (c.value?.toString() ?? "") === ((categoriaVal ?? "").toString())
            );
            const categoriaState = categoriaVal !== undefined && categoriaVal !== null && categoriaVal !== ""
                ? { value: (categoriaVal).toString(), label: categoriaLabel || categoriaFromList?.label || "" }
                : { label: "Todos", value: "" };

            this.setState({
                seller: sellerId
                    ? {
                        value: sellerId,
                        label:
                            currFiltro.idSellerLabel ||
                            sellerFromList?.label ||
                            "Seleccionado"
                    }
                    : { label: "Todos", value: "" },
                marca: marcaState,
                categoria: categoriaState
            });
        }

        // 🔥 EXTRA (MUY IMPORTANTE)
        // si llegan sellers después (async), reintentar armar el label
        if (prevProps.sellers !== this.props.sellers) {
            const sellerId = currFiltro.idSeller;

            if (sellerId && this.state.seller?.label === "Seleccionado") {
                const sellerFromList = (this.props.sellers || []).find(
                    s => s.value?.toString() === sellerId?.toString()
                );

                if (sellerFromList) {
                    this.setState({
                        seller: sellerFromList
                    });
                }
            }
        }

        if (prevFiltro !== currFiltro) {
            const stockValue = currFiltro.sinStock;
            const sinStock =
                stockValue === true || stockValue === "true"
                    ? { value: true, label: "Sin Stock" }
                    : stockValue === false || stockValue === "false"
                        ? { value: false, label: "Con Stock" }
                        : { value: "", label: "Todos" };

            this.setState({ sinStock });
        }

        // Sincronizar opciones de tipoPublicacion cuando llegan desde Redux
        if (prevProps.tipoPublicacion !== this.props.tipoPublicacion) {
            this.mapTipoPublicacion();
        }

        // Si cambió el filtro (por ejemplo vuelvo de la vista de publicación),
        // reconstruir el label/valor de idTipoPublicacion si es necesario
        if (prevFiltro !== currFiltro) {
            const idTipo = currFiltro?.idTipoPublicacion ?? currFiltro?.idTipoPubli;
            const labelTipo = currFiltro?.idTipoPublicacionLabel;

            if (idTipo) {
                const found = (this.props.tipoPublicacion || []).find(t => (t.codigo ?? t.value)?.toString() === idTipo?.toString());
                const newLabel = this.state.idTipoPublicacion?.label || labelTipo || found?.descripcion || found?.label || "";

                this.setState({
                    idTipoPublicacion: {
                        value: idTipo ?? "",
                        label: newLabel ?? "Todos"
                    }
                });

                // Asegurar que la opción seleccionada exista en la lista de opciones
                if (found) {
                    const exists = (this.state.tipoPublicacion || []).some(
                        tp => tp.value?.toString() === (found.codigo ?? found.value)?.toString()
                    );
                    if (!exists) {
                        this.setState(prev => ({
                            tipoPublicacion: [
                                { value: found.codigo ?? found.value ?? "", label: found.descripcion ?? found.label ?? newLabel ?? "Todos" },
                                ...(prev.tipoPublicacion || [])
                            ]
                        }));
                    }
                }
            } else {
                // limpiar
                this.setState({ idTipoPublicacion: { label: "Todos", value: "" } });
            }
        }
    }

    getDefaultFilterParams = () => ({
        idSeller: this.props.allowSearchBySeller ? null : this.props.idSeller,
        fechaPubHasta: fechaFiltro.hasta,
        fechaPubDesde: fechaFiltro.desde,
        idTipoPubli: null,
        idTipoPublicacion: null
    });

    componentWillUnmount() {
        if (!this.props.clearFilterOnUnmount) return;

        if (localStorage.getItem(PUBLICACIONES_PRESERVE_FILTER_KEY) === "true") {
            return;
        }

        if (this.props.persistFilterInRedux !== false) {
            this.props.setFiltroPublicacion(this.getDefaultFilterParams());
        }
        localStorage.removeItem("pagina");
    }

    getResultadosPublicaciones = (publicaciones) => {
        if (Array.isArray(publicaciones)) return publicaciones;
        if (Array.isArray(publicaciones?.elementos)) return publicaciones.elementos;
        return [];
    }


    onSelectSearchInputCategorias = (descripcion, action) => {
        if (action?.action !== 'input-change') return;
        this.props.fetchCategorias(descripcion || "");
    };

    onSelectSearchInputMarcas = (descripcion, action) => {
        if (action?.action !== 'input-change') return;
        this.props.fetchMarcas(descripcion || "");
    };

    onSelectSearchInputSellers = (descripcion, action) => {
        // Solo buscar cuando el usuario escribe, no cuando selecciona
        if (action.action === 'input-change') {
            this.props.fetchSellersFilter({ 
                Descripcion: descripcion,
                Page: 1,
                PageSize: 100
            });
        }
    }

    selectSearchHandler = (options, config) => {
        this.setState({ [config.name]: options });
    };

    onFilter = (event) => {
        event.preventDefault();

        const skuSellerValue = (this.state.skuSeller || "").toString().trim();
        const skuMarketValue = (this.state.skuMarket || "").toString().trim();
        const idPublicacionValue = (this.state.idPublicacion || "").toString().trim();

        let filtroPublicacion = {
            estado: this.state.estado.value,
            estadoLabel: this.state.estado.label,
            marca: this.state.marca.value,
            marcaLabel: this.state.marca.label,
            categoria: this.state.categoria.value,
            categoriaLabel: this.state.categoria.label,
            idSeller: this.state.seller.value,
            idSellerLabel: this.state.seller.label,
            // Mantener ambas claves para compatibilidad
            idTipoPublicacion: this.state.idTipoPublicacion.value,
            idTipoPubli: this.state.idTipoPublicacion.value,
            idTipoPublicacionLabel: this.state.idTipoPublicacion.label,
            skuSeller: skuSellerValue,
            skuMarket: skuMarketValue,

            fechaPubDesde: this.state.fechaPubDesde,
            fechaPubHasta: this.state.fechaPubHasta,

            sinStock: this.state.sinStock?.value,
            sinStockLabel: this.state.sinStock?.label,
            idPublicacion: idPublicacionValue,
        };

        if (!this.props.allowSearchBySeller) {
            filtroPublicacion.idSeller = this.props.idSeller;
        }

        // Determinar qué payload enviar según identificadores únicos (prioridad: idPublicacion > skuSeller > skuMarket)
        let payloadParaExportar;
        let filtroParaRedux; // Será diferente si hay identificador único
        
        if (idPublicacionValue) {
            // Si hay idPublicacion, enviar solo ese (sin fechas ni otros filtros)
            payloadParaExportar = { idPublicacion: idPublicacionValue };
            // Guardar en Redux SOLO el identificador para evitar arrastre de filtros previos
            filtroParaRedux = { 
                idPublicacion: idPublicacionValue,
                fechaPubDesde: null,
                fechaPubHasta: null
            };
        } else if (skuSellerValue) {
            // Si no hay idPublicacion pero hay skuSeller, enviar solo ese (sin fechas ni otros filtros)
            payloadParaExportar = { skuSeller: skuSellerValue };
            // Guardar en Redux SOLO el identificador para evitar arrastre de filtros previos
            filtroParaRedux = { 
                skuSeller: skuSellerValue,
                fechaPubDesde: null,
                fechaPubHasta: null
            };
        } else if (skuMarketValue) {
            // Si no hay idPublicacion ni skuSeller pero hay skuMarket, enviar solo ese (sin fechas ni otros filtros)
            payloadParaExportar = { skuMarket: skuMarketValue };
            // Guardar en Redux SOLO el identificador para evitar arrastre de filtros previos
            filtroParaRedux = { 
                skuMarket: skuMarketValue,
                fechaPubDesde: null,
                fechaPubHasta: null
            };
        } else {
            // Si no hay identificadores únicos, enviar y guardar el filtro completo
            payloadParaExportar = {
                idSeller: Number.isNaN(Number.parseInt(filtroPublicacion.idSeller)) ? null : Number.parseInt(filtroPublicacion.idSeller),
                fechaPubDesde: filtroPublicacion.fechaPubDesde,
                fechaPubHasta: filtroPublicacion.fechaPubHasta,
                categoria: Number.isNaN(Number.parseInt(filtroPublicacion.categoria)) ? null : Number.parseInt(filtroPublicacion.categoria),
                marca: Number.isNaN(Number.parseInt(filtroPublicacion.marca)) ? null : Number.parseInt(filtroPublicacion.marca),
                estado: filtroPublicacion.estado,
                skuSeller: filtroPublicacion.skuSeller,
                skuMarket: filtroPublicacion.skuMarket,
                sinStock: filtroPublicacion.sinStock === "" ? null : filtroPublicacion.sinStock,
                idPublicacion: filtroPublicacion.idPublicacion,
                idTipoPublicacion: filtroPublicacion.idTipoPublicacion,
                idTipoPubli: filtroPublicacion.idTipoPubli
            };
            // Guardar el filtro completo en Redux cuando no hay identificadores únicos
            filtroParaRedux = filtroPublicacion;
        }

        // Guardar filtro en Redux (será solo el identificador único sin fechas si existe, o el filtro completo si no)
        if (this.props.persistFilterInRedux !== false) {
            this.props.setFiltroPublicacion(filtroParaRedux);
        }

        // Pasar el payload correspondiente al parent
        if (typeof this.props.requestParaExportar === 'function') {
            this.props.requestParaExportar(payloadParaExportar);
        } else {
            // eslint-disable-next-line no-console
            console.warn('requestParaExportar no está definido o no es función');
        }
    };

    onClearFilter = (event) => {
        event.preventDefault();
        this.props.setInitialPage();

        let params = this.getDefaultFilterParams();

        if (this.props.shouldFetchOnClear) {
            this.props.fetchPublicacionesEncabezado(params);
        }

        if (this.props.persistFilterInRedux !== false) {
            this.props.setFiltroPublicacion(params);
        }
        localStorage.removeItem("pagina");

        this.setState({
            marca: { label: "Todos", value: "" },
            categoria: { label: "Todos", value: "" },
            estado: { label: "Todos", value: "" },
            estadoBloqueadoPorRespuesta: false,
            seller: { label: "Todos", value: "" },
            skuSeller: "",
            skuMarket: "",
            fechaPubDesde: fechaFiltro.desde,
            fechaPubHasta: fechaFiltro.hasta,
            idTipoPublicacion: { label: "Todos", value: "" },
            sinStock: { label: "Todos", value: "" },
            idPublicacion: ""
        });

        if (this.props.onClearCantidad) {
            this.props.onClearCantidad();
        }
    };

    handleChange = (event) => {
        const { name, value } = event.target;
        const trimmed = (value || "").toString().trim();

        // 🔹 Manejo exclusivo de fechas
        if (name === "fechaPubDesde") {
            this.setState({ fechaPubDesde: value });
            return;
        }

        if (name === "fechaPubHasta") {
            this.setState({ fechaPubHasta: value });
            return;
        }

        // Actualizo el campo normalmente
        this.setState({ [name]: value });

        // 🔹 Si escribe SKU → limpio otros filtros (PERO NO FECHAS)
        if ((name === "skuSeller" || name === "skuMarket") && trimmed !== "") {
            this.setState({
                ...(name === "skuSeller" ? { skuMarket: "" } : { skuSeller: "" }),
                idPublicacion: "",
                marca: { label: "Todos", value: "" },
                categoria: { label: "Todos", value: "" },
                seller: { label: "Todos", value: "" },
                estado: { label: "Todos", value: "" },
                idTipoPublicacion: { label: "Todos", value: "" },
                sinStock: { label: "Todos", value: "" },
                // 🚫 NO tocar fechas
            });
            return;
        }

        // 🔹 Si escribe ID Publicación → limpio otros filtros (PERO NO FECHAS)
        if (name === "idPublicacion" && trimmed !== "") {
            this.setState({
                skuSeller: "",
                skuMarket: "",
                marca: { label: "Todos", value: "" },
                categoria: { label: "Todos", value: "" },
                seller: { label: "Todos", value: "" },
                estado: { label: "Todos", value: "" },
                idTipoPublicacion: { label: "Todos", value: "" },
                sinStock: { label: "Todos", value: "" },
                estadoBloqueadoPorRespuesta: false
                // 🚫 NO tocar fechas
            });
        }
    };

    mapVariaciones = () => {
        let variaciones = [];
        if (this.props.variaciones) {
            this.props.variaciones.forEach(variacion =>
                variaciones.unshift({
                    label: this.switchEstado(this.normalizeEstadoValue(variacion.descripcion ?? variacion)) ?? "Todos",
                    value: this.normalizeEstadoValue(variacion.descripcion ?? variacion) ?? ""
                })
            );
        }

        if (
            this.state.estado?.value &&
            !variaciones.some(item => item.value === this.state.estado.value)
        ) {
            variaciones.unshift({
                value: this.state.estado.value,
                label: this.state.estado.label
            });
        }

        this.setState({ variaciones: variaciones });
    }

    mapTipoPublicacion = () => {
        let tipoPublicacion = [];
        if (this.props.tipoPublicacion) {
            this.props.tipoPublicacion.forEach(item =>
                tipoPublicacion.unshift({
                    label: item.descripcion,
                    value: item.codigo
                })
            );
        }

        // Asegurar que la opción actualmente seleccionada esté presente en las opciones
        if (
            this.state.idTipoPublicacion?.value &&
            !tipoPublicacion.some(item => item.value?.toString() === this.state.idTipoPublicacion.value?.toString())
        ) {
            tipoPublicacion.unshift({
                value: this.state.idTipoPublicacion.value,
                label: this.state.idTipoPublicacion.label
            });
        }

        this.setState({ tipoPublicacion });
    };

    switchEstado = (estado) => {
        switch (estado) {
            case "activo":
                return "ACTIVO";
            case "activa":
                return "ACTIVO";
            case "pendiente_activacion":
                return "PENDIENTE";
            case "pendiente":
                return "PENDIENTE";
            case "pausado":
                return "PAUSADO";
            case "pausada":
                return "PAUSADO";
            case "en_revision":
                return "EN REVISIÓN";
            case "revision":
                return "EN REVISIÓN";
            case "eliminado":
            case "Eliminado":
                return "ELIMINADO";
            default:
                return typeof estado === "string" ? estado : "Todos";
        }
    };

    mapSellers = () => {
        // SIEMPRE cargar sellers cuando se abre el dropdown
        // Esto limpia cualquier filtro previo del dashboard u otras vistas
        this.props.fetchSellersFilter({
            Descripcion: "",
            Page: 1,
            PageSize: 100
        });
    }

    render() {
        const { allowSearchBySeller, loadingExport, hideIdPublicacion } = this.props;
        const { variaciones } = this.state;

        // Construir lista de sellers sin agregar "Todos" aquí (se maneja en el estado local)
        let listaSeller = (this.props.sellers || []).map(item => ({
            label: item.label,
            value: item.value ? item.value.toString() : ""
        }));

        // 🔥 asegurar que el seller seleccionado esté en la lista
        if (this.state.seller?.value && !listaSeller.some(s => s.value === this.state.seller.value)) {
            listaSeller.unshift(this.state.seller);
        }

        // Agregar opción "Todos" si no está ya en la lista
        if (listaSeller.length > 0 && listaSeller[0]?.value !== "") {
            listaSeller.unshift({ value: "", label: "Todos" });
        }

        if (variaciones.length > 0 && variaciones[0]?.value !== "") {
            variaciones.unshift({ value: "", label: "Todos" });
        }

        const listaCategoria = (this.props.categorias || []).map(item => ({
            label: item.label,
            value: item.value.toString()
        }));

        const listaMarca = (this.props.marcas || []).map(item => ({
            label: item.label,
            value: item.value.toString()
        }));

        // Asegurar que la marca/categoría seleccionada aparezcan en las opciones aunque la lista async no las incluya
        if (this.state.marca?.value && !listaMarca.some(m => m.value === this.state.marca.value)) {
            listaMarca.unshift(this.state.marca);
        }
        if (this.state.categoria?.value && !listaCategoria.some(c => c.value === this.state.categoria.value)) {
            listaCategoria.unshift(this.state.categoria);
        }

        const stockOpciones = [
            { value: "", label: "Todos" },
            { value: true, label: "Sin Stock" },
            { value: false, label: "Con Stock" }
        ];

        const classIsModerador = allowSearchBySeller ? "col-lg-2" : "col-lg-3";

        const skuSellerValue = (this.state.skuSeller || "").toString().trim();
        const skuMarketValue = (this.state.skuMarket || "").toString().trim();
        const idPublicacionValue = hideIdPublicacion ? "" : (this.state.idPublicacion || "").toString().trim();

        const isSearchBySkuSeller = skuSellerValue !== "";
        const isSearchBySkuMarket = skuMarketValue !== "";
        const isSearchBySku = skuSellerValue !== "" || skuMarketValue !== "";
        const isSearchById = idPublicacionValue !== "";
        const isFiltering = isSearchBySku || isSearchById;
        const isEstadoDisabled = isFiltering || this.state.estadoBloqueadoPorRespuesta;

        return (
            <div className="card card-body filter-card">
                <form
                    className="row form-material"
                    onSubmit={this.onFilter}
                    onReset={this.onClearFilter}
                >
                    {!hideIdPublicacion && (
                        <div className={classIsModerador}>
                            <label htmlFor="idPublicacionPublicacionFilter" className="label-oscura">ID Publicación</label>
                            <input
                                id="idPublicacionPublicacionesFilter"
                                type="text"
                                name="idPublicacion"
                                onChange={this.handleChange}
                                value={this.state.idPublicacion}
                                className="form-control"
                                disabled={isSearchBySku}
                            />
                        </div>
                    )}

                    {allowSearchBySeller &&
                        <div className={classIsModerador}>
                            <label htmlFor="sellerPublicacionesFilter" className="label-oscura">Seller</label>
                            <Select
                                id="sellerPublicacionesFilter"
                                name="seller"
                                value={this.state.seller}
                                options={listaSeller}
                                onChange={this.selectSearchHandler}
                                onMenuOpen={this.mapSellers}
                                onInputChange={this.onSelectSearchInputSellers}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                styles={customStyleFilter}
                            {...filterSelectMenuPortalProps}
                                isDisabled={isFiltering}
                            />
                        </div>
                    }
                    <div className={classIsModerador}>
                        <label htmlFor="skuSellerPublicacionesFilter" className="label-oscura">Sku Seller</label>
                        <input
                            id="skuSellerPublicacionesFilter"
                            type="text"
                            name="skuSeller"
                            onChange={this.handleChange}
                            value={this.state.skuSeller}
                            className="form-control"
                            disabled={isSearchById || isSearchBySkuMarket}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label htmlFor="skuMarketPublicacionesFilter" className="label-oscura">Sku Market</label>
                        <input
                            id="skuMarketPublicacionesFilter"
                            type="text"
                            name="skuMarket"
                            onChange={this.handleChange}
                            value={this.state.skuMarket}
                            className="form-control"
                            disabled={isSearchById || isSearchBySkuSeller}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label htmlFor="marcaPublicacionesFilter" className="label-oscura">Marca</label>
                        <Select
                            id="marcaPublicacionesFilter"
                            name="marca"
                            value={this.state.marca}
                            options={listaMarca}
                            onInputChange={this.onSelectSearchInputMarcas}
                            onChange={this.selectSearchHandler}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyleFilter}
                            {...filterSelectMenuPortalProps}
                            isDisabled={isFiltering}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label htmlFor="categoriaPublicacionesFilter" className="label-oscura">Categoria</label>
                        <Select
                            id="categoriaPublicacionesFilter"
                            name="categoria"
                            value={this.state.categoria}
                            options={listaCategoria}
                            onInputChange={this.onSelectSearchInputCategorias}
                            onChange={this.selectSearchHandler}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyleFilter}
                            {...filterSelectMenuPortalProps}
                            isDisabled={isFiltering}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label htmlFor="estadoPublicacionesFilter" className="label-oscura">Estado</label>
                        <Select
                            id="estadoPublicacionesFilter"
                            name="estado"
                            options={this.state.variaciones}
                            onChange={this.selectSearchHandler}
                            value={this.state.estado}
                            onMenuOpen={this.mapVariaciones}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyleFilter}
                            {...filterSelectMenuPortalProps}
                            isDisabled={isEstadoDisabled}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label htmlFor="fechaDesdePublicacionesFilter" className="label-oscura">
                            Fecha desde
                        </label>
                        <input
                            id="fechaDesdePublicacionesFilter"
                            type={isFiltering ? "text" : "date"}
                            name="fechaPubDesde"
                            className="form-control"
                            onChange={this.handleChange}
                            value={isFiltering ? "--/--/--" : this.state.fechaPubDesde}
                            disabled={isFiltering}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label htmlFor="fechaHastaPublicacionesFilter" className="label-oscura">
                            Fecha hasta
                        </label>
                        <input
                            id="fechaHastaPublicacionesFilter"
                            type={isFiltering ? "text" : "date"}
                            name="fechaPubHasta"
                            className="form-control"
                            onChange={this.handleChange}
                            value={isFiltering ? "--/--/--" : this.state.fechaPubHasta}
                            disabled={isFiltering}
                        />
                    </div>

                    {allowSearchBySeller &&
                        <div className="col-lg-2">
                            <label htmlFor="tipoPublicacionPublicacionesFilter" className="label-oscura">Tipo publicación</label>
                            <Select
                                id="tipoPublicacionPublicacionesFilter"
                                name="idTipoPublicacion"
                                options={this.state.tipoPublicacion}
                                onChange={this.selectSearchHandler}
                                value={this.state.idTipoPublicacion}
                                onMenuOpen={this.mapTipoPublicacion}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                placeholder=""
                                styles={customStyleFilter}
                            {...filterSelectMenuPortalProps}
                                isDisabled={isFiltering}
                            />
                        </div>
                    }

                    <div className={classIsModerador}>
                        <label htmlFor="stockPublicacionesFilter" className="label-oscura">Stock</label>
                        <Select
                            id="stockPublicacionesFilter"
                            name="stock"
                            options={stockOpciones}
                            onChange={(e) => this.setState({ sinStock: e })}
                            value={this.state.sinStock}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            placeholder=""
                            styles={customStyleFilter}
                            {...filterSelectMenuPortalProps}
                            isDisabled={isFiltering}
                        />
                    </div>

                    <div className="row p-10">
                        <div className="col-12 col-sm-6 text-center text-sm-end mt-sm-3">
                            <button
                                className="btn d-inline btn-sm btn-grey m-r-10"
                                disabled={loadingExport}
                                type="submit"
                            >
                                Buscar
                            </button>
                            <button className="btn btn-sm btn-grey d-inline" type="reset">
                                Limpiar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}
PublicacionesFilter.propTypes = {
    filtro: PropTypes.object,
    filtroPublicaciones: PropTypes.shape({
        estado: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        skuSeller: PropTypes.number,
        marcaLabel: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        categoriaLabel: PropTypes.string,
        categoria: PropTypes.shape({
            nombre: PropTypes.string,
        }),
        idSellerLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        idTipoPublicacionLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        idTipoPublicacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        sinStockLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        sinStock: PropTypes.bool,
        fechaPubDesde: PropTypes.string,
        fechaPubHasta: PropTypes.string,
        skuMarket: PropTypes.number,
        idPublicacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        estadoLabel: PropTypes.string,
        internacional: PropTypes.bool
    }),
    fetchCategorias: PropTypes.func,
    fetchMarcas: PropTypes.func,
    fetchSellersFilter: PropTypes.func,
    allowSearchBySeller: PropTypes.bool,
    idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setFiltroPublicacion: PropTypes.func,
    setInitialPage: PropTypes.func,
    shouldFetchOnClear: PropTypes.bool,
    clearFilterOnUnmount: PropTypes.bool,
    persistFilterInRedux: PropTypes.bool,
    fetchPublicacionesEncabezado: PropTypes.func,
    onClearCantidad: PropTypes.func,
    variaciones: PropTypes.array,
    tipoPublicacion: PropTypes.array,
    loadingExport: PropTypes.bool,
    hideIdPublicacion: PropTypes.bool,
    sellers: PropTypes.array,
    categorias: PropTypes.array,
    marcas: PropTypes.array,
    requestParaExportar: PropTypes.func,
    publicaciones: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        publicaciones: PropTypes.array,
    })])
}

const mapStateToProps = state => ({
    publicaciones: state.publicaciones.publicaciones,
    loadingPublicaciones: state.publicaciones.loadingPublicaciones,
    marcas: state.publicaciones.marcas,
    categorias: state.publicaciones.categorias,
    variaciones: state.publicaciones.variacionesPublicacion,
    sellers: state.sellers.filteredSellers,
    idSeller: state.general.idSeller,
    tipoPublicacion: state.tiposPublicacion.tiposPublicaciones.elementos,
    filtroPublicaciones: state.publicaciones.filtroPublicaciones,
});

export default connect(mapStateToProps, {
    fetchMarcas,
    fetchCategorias,
    fetchPublicaciones,
    fetchSellersFilter,
    setFiltroPublicacion,
    fetchPublicacionesEncabezado,
    // getSellerDesplegable
})(PublicacionesFilter);
